/**
 * MONEY CONVENTION — read this once.
 *
 * Every monetary amount in the domain is an integer number of euro **cents**,
 * stored **excluding BTW**. BTW (21%) is added by the pricing engine for display
 * and order totals, anchored on the excl. amount (see pricing/vat.ts).
 *
 * Seed RATES (pricePerM2, operation costs) MAY carry fractional cents. The engine
 * rounds EACH breakdown line to whole cents and sums them for the unit price, then
 * multiplies by quantity — exactly how the Timmers webshop computes it (verified
 * against the live shop). Every amount RETURNED by the engine is an integer.
 */

/** An amount in euro cents. Integer when returned by the engine; rates may be fractional. */
export type Cents = number;

/** Dutch VAT rate applied to all products. */
export const VAT_RATE = 0.21;
